import React from 'react';
import { Seo, Order } from 'components';

export default () => (
  <>
    <Seo title={'Заявка'} robots={'noindex, follow'} />
    <Order fullscreen={true} department={true} />
  </>
);
